import './Menu.css';
import React from 'react';
import { useLocation } from 'react-router-dom';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import LanguageIcon from '@mui/icons-material/Language';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import DrawerRight from './DrawerRight';
import Lang from '../lang/Lang';
import menuRoute from '../../config/menuRoute';
import FireTvPad from '../button/FireTvPad';

function Menu() {
  const location = useLocation();
  const currentRoute = menuRoute.find((item) => item.path === location.pathname) || {};

  const currentRouteName = currentRoute.label || '';
  function getRouteIcon(routeLabel) {
    const icons = {
      home: <HomeRoundedIcon sx={{ fontSize: 25 }} />,
      projectMobile: <SmartphoneIcon sx={{ fontSize: 25 }} />,
      projectWeb: <LanguageIcon sx={{ fontSize: 25 }} />,
    };

    // Retourne l'icône correspondante ou une icône par défaut
    return icons[routeLabel] || <HomeRoundedIcon sx={{ fontSize: 25 }} />;
  }
  return (
    <div className="menu-right">
      <div className="menu-fixed">
        <DrawerRight position="right" />
        <span className="vertical-text">{getRouteIcon(currentRouteName)}</span>
        <div className="lang">
          <Lang />
        </div>
        <FireTvPad
          sectionsRef={[]}
        />
      </div>

    </div>
  );
}

export default Menu;
